<div class="modal-header">
  <h5 class="modal-title">{{ (existing ? 'EDIT_CROSS_REFERENCE' : 'ADD_CROSS_REFERENCE') | translate }}</h5>
  <button type="button" class="btn-close" (click)="activeModal.dismiss()"></button>
</div>
<div class="modal-body">
  <div class="form-group mb-2">
    <label>{{ 'CROSS_BRAND' | translate }}</label>
    <input type="text" class="form-control" [(ngModel)]="model.crossBrand" />
  </div>
  <div class="form-group mb-2">
    <label>{{ 'CROSS_REFERENCE' | translate }}</label> <span class="text-danger">*</span>
    <input type="text" class="form-control" [(ngModel)]="model.crossReference" />
  </div>
  <div class="form-group mb-2">
    <label>{{ 'OTTO_PRODUCT_ID' | translate }}</label> <span class="text-danger">*</span>
    <input type="text" class="form-control" [(ngModel)]="model.ottoProductId" />
  </div>
  <div class="form-group mb-2">
    <label>{{ 'NOTE' | translate }}</label>
    <input type="text" class="form-control" [(ngModel)]="model.note" />
  </div>
  @if (error) {
    <div class="alert alert-danger">{{ error | translate }}</div>
  }
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="activeModal.dismiss()">{{ 'CANCEL' | translate }}</button>
  <button type="button" class="btn btn-primary" [disabled]="saving" (click)="save()">{{ 'SAVE' | translate }}</button>
</div>
